import { gql } from '@apollo/client';
import { CONDITION_INSTANCE_FIELDS } from "./bpm";
export const STATE_TREE_ROLE_FIELDS = gql`
  fragment StateTreeRoleDtoFields on StateTreeRoleDto {
    id
    name
  }
`;
export const TREE_NODE_FIELDS = gql`
  fragment TreeNodeFields on TreeNodeDto {
    id
    parentId
    labelSon
    translatedLabelSon
    level
    text
    translatedName
    code
  }
`;
export const BUTTON_CONFIG_FIELDS = gql`
  fragment ButtonConfigFields on TreeButtonConfigDto {
    textColor
    confirmMessage
    translatedConfirmMessage
    confirmMessageTranslations
    colorClass
    label
    translatedLabel
    labelTranslations
    icon
    size
    positionIcon
    buttonType
    colorHex
    textColorHex
  }
`;
export const STATE_TREE_FIELDS = gql`
  ${BUTTON_CONFIG_FIELDS}
  ${TREE_NODE_FIELDS}
  fragment StateTreeFields on StateTreeDto {
    id
    parentId
    treeStart {
      ...TreeNodeFields
    }
    treeNext {
      ...TreeNodeFields
    }
    buttonConfig {
      ...ButtonConfigFields
    }
  }
`;
export const STATE_TREE_ALL_FIELDS = gql`
  ${STATE_TREE_FIELDS}
  fragment StateTreeAllFields on StateTreeDto {
    ...StateTreeFields
    disabled
    unfulfilledConditions
  }
`;
export const STATE_TREE_CONFIGURATION_FIELDS = gql`
  ${STATE_TREE_FIELDS}
  ${CONDITION_INSTANCE_FIELDS}
  ${STATE_TREE_ROLE_FIELDS}
  fragment StateTreeConfigurationFields on StateTreeDto {
    ...StateTreeFields
    role {
      ...StateTreeRoleDtoFields
    }
    configuredConditions {
      ...ConditionInstanceFields
    }
    level
    action
    automatic
    withoutButton
  }
`;
export const EMBEDED_TREE_FIELDS = gql`
  fragment EmbededTreeFields on EmbededTreeDto {
    treelevel4
    treelevel2
    treelevel3
    treelevel1
  }
`;
export const EMBEBED_TREE_VALUES_FIELDS = gql`
  fragment EmbebedTreeValuesFields on EmbededTreeValuesDto {
    code
    label
  }
`;
export const EMBEBED_TREE_MAP_FIELDS = gql`
  ${EMBEBED_TREE_VALUES_FIELDS}
  fragment EmbebedTreeMapFields on EmbededTreeMapDto {
    rootCode
    level1 {
      ...EmbebedTreeValuesFields
    }
    level2 {
      ...EmbebedTreeValuesFields
    }
    level3 {
      ...EmbebedTreeValuesFields
    }
    level4 {
      ...EmbebedTreeValuesFields
    }
  }
`;